import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#006341",
    },
    arrowIcon: {
      // main: "#fff",
    },
    button: {
      main: {
        active: {
          // background: "#ffbc0d",
          // text: "#000",
        },
      },
      details: {
        normal: {
          // text: "#000",
        },
        active: {
          // background: "#fff",
          // text: "#000",
        },
      },
    },
    text: {
      primary: "#333",
      main: "#000",
      light: "#B69A81",
      tableItems: {
        main: "#2d2d2d",
        highlight: "#fff",
      },
      title: "#006341",
    },
    background: {
      main: "#fff",
      details: {
        main: "#808285",
        highlight: "#006341",
      },
    },
  },
  typography: {
    fontFamily: "Nunito Sans,Arial,sans-serif",
    h3: {
      fontWeight: 600,
      fontSize: "2.5rem",
      lineHeight: "2.75rem",
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 787,
      md: 1024,
      lg: 1200,
      xl: 1536,
    },
  },
});

export default theme;
